import Swiper from "swiper";
import { Navigation, EffectFade } from "swiper/modules";

export const valuesSlider = (function () {
  const init = function () {
    if (!valuesSlider.length) {
      return;
    }

    const swiper = new Swiper(".values-slider", {
      modules: [Navigation, EffectFade],
      slidesPerView: "auto",
      spaceBetween: 40,
      effect: "fade",
      fadeEffect: {
        crossFade: true,
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });

    const menu = document.getElementById("circle");
    const items = menu.querySelectorAll(".our-values__circle-item[data-value]");
    const itemCount = items.length;
    const eachSlice = 360 / itemCount;

    items.forEach(function (item, index) {
      let itemContent = item.querySelector("img");
      let degree = index * eachSlice;

      item.style.transform = "rotate(" + degree + "deg)";
      item.dataset.degree = degree;
      itemContent.style.transform = "rotate(" + degree * -1 + "deg)";

      if (window.innerWidth >= 1366) {
        item.style.transform = "rotate(" + (degree - 90) + "deg)";
        itemContent.style.transform = "rotate(" + (degree * -1 + 90) + "deg)";
      }

      setTimeout(function () {
        itemContent.classList.add("transition");
        item.classList.add("transition");
      }, 100);

      if (parseFloat(item.dataset.value) === swiper.activeIndex) {
        item.classList.add("active");
      }

      item.addEventListener("click", function () {
        swiper.slides.forEach(function (_, i) {
          if (i === parseFloat(item.dataset.value)) {
            swiper.slideTo(i);
          }
        });
      });
    });

    function rotateCircle(degrees) {
      items.forEach(function (item) {
        let itemContent = item.querySelector("img");
        let currentDegree = parseFloat(item.dataset.degree);
        let newDegree = currentDegree + degrees;

        item.style.transform = "rotate(" + newDegree + "deg)";
        item.dataset.degree = newDegree;
        itemContent.style.transform = "rotate(" + newDegree * -1 + "deg)";

        if (window.innerWidth >= 1366) {
          item.style.transform = "rotate(" + (newDegree - 90) + "deg)";
          itemContent.style.transform =
            "rotate(" + (newDegree * -1 + 90) + "deg)";
        }
      });
    }

    swiper.on("slideChange", function () {
      items.forEach(function (item) {
        if (parseFloat(item.dataset.value) === swiper.activeIndex) {
          item.classList.add("active");
        } else {
          item.classList.remove("active");
        }
      });
      if (swiper.activeIndex > swiper.previousIndex) {
        rotateCircle(90 * (swiper.activeIndex - swiper.previousIndex));
      } else if (swiper.activeIndex < swiper.previousIndex) {
        rotateCircle(-90 * (swiper.previousIndex - swiper.activeIndex));
      }
    });
  };

  return {
    init,
  };
})();
